// extracted by mini-css-extract-plugin
export default {"wellcome":"Wellcome_wellcome__dLVqD","text":"Wellcome_text__Y7WZh","name":"Wellcome_name__OL3ZV"};